import './mainCustomer.css';
import Navbar from '../navbar/Navbar';
import Sidemenu from '../sidemenu/Sidemenu';
import TokenError from '../tokenError';
import { Button, Grid2, Typography, Avatar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import starIcon from '../../assets/icons/starIcon.png';
import { CSVLink } from "react-csv";
import axios from 'axios';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { Dialog, DialogTitle, DialogContent, TextField,   Select,
    MenuItem,
    Box,
    FormControl} from '@mui/material';

const Dashboard = () => {

    const serverUrl = config.serverUrl;
    const navigate = useNavigate();

    const [rows, setRows] = useState([]);
    const [allData, setAllData] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [customerId, setCustomerId] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const clientCities = JSON.parse(localStorage.getItem("cities")) || [];

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);


    const [open, setOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [type, setType] = useState('credit');
  
    const handleOpen = (row) => {
        setSelectedRow(row);
        setType('credit'); // Reset to default when opening modal
        setAmount(''); // Clear amount
        setReason(''); // Clear reason
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleInputChange = (e) => {
        setCustomerId(e.target.value);
    };
    const handlePhoneChange = (e) => {
        setCustomerPhone(e.target.value);
    };

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();

            const url = `${serverUrl}/customer/fetch_all`;
            const obj={
                token: token, timestamp: timestamp
            }

            const response =  await makeGetRequestToUrl(url, obj);

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            
            if(response.flag === 200){
                const customersData = response.data;
                setRows(customersData);
                setFilteredRows(customersData);
                const formattedData = formatDataForCSV(customersData);
                setAllData(formattedData);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setRows([]);
            setFilteredRows([]);
        }
    };
    
    useEffect(() => {
        fetchData();
    }, []);

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...filteredRows].sort((a, b) => {
        if (a[property] < b[property]) return isAscending ? -1 : 1;
        if (a[property] > b[property]) return isAscending ? 1 : -1;
        return 0;
        });
        // setRows(sortedRows);
        setFilteredRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // const sortedAndPaginatedRows = Array.isArray(rows) 
    // ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    // : [];

    useEffect(() => {
        if(customerPhone && customerId){
            const filteredPhoneData = rows.filter((item) => (item.user_id === parseInt(customerId, 10) && item.phone_number === customerPhone));
            console.log('Filtered data:', filteredPhoneData);
            setFilteredRows(filteredPhoneData);
            setPage(0);
        }
        else if(customerId){
            const filteredData = rows.filter((item) => 
                // item.user_id === parseInt(customerId, 10)
                item.user_id.toString().includes(customerId) || customerId === ''
            );
            console.log('Filtered data:', filteredData);
            setFilteredRows(filteredData);
            setPage(0);
    
        }
        else if(customerPhone){
            const filteredPhoneData = rows.filter((item) => 
                // item.phone_number === customerPhone
                item.phone_number.toString().includes(customerPhone) || customerPhone === ''
            );
            console.log('Filtered data:', filteredPhoneData);
            setFilteredRows(filteredPhoneData);
            setPage(0);
        }
        else{
            setFilteredRows(rows);
        }
    },[customerId, customerPhone])

    useEffect(() => {
        const paginated = Array.isArray(filteredRows)
            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [filteredRows, page, rowsPerPage]);

    const formatDataForCSV = (data) => {
        return data.map((item) => ({
            ...item,

            date_of_birth : item.date_of_birth.split('T')[0],

            email_verification_status : item.email_verification_status==1 ? 'Verified' : 'Not Verified',
            gender : item.gender==1 ? 'Male' : item.gender==2 ? 'Female' : item.gender==3 ? 'Others' : 'Others',

            city_id : (clientCities.find(city => city.city_id === item.city_id)) ? (clientCities.find(city => city.city_id === item.city_id)).city_name : '--',
            registered_city_id: (clientCities.find(city => city.city_id === item.registered_city_id)) ? (clientCities.find(city => city.city_id === item.registered_city_id)).city_name : '--',
            
        }));
    };

     // Define custom headers
     const headers = [
        { label: 'Customer ID', key: 'user_id' },
        { label: 'Customer Name', key: 'user_name' },
        { label: 'Email', key: 'user_email' },
        { label: 'Phone Number', key: 'phone_number' },
        { label: 'Customer Image', key: 'user_image' },
        { label: 'Email Varification Satus', key: 'email_verification_status' },
        { label: 'City', key: 'city_id' },
        { label: 'Registered City', key: 'registered_city_id' },
        { label: 'Gender', key: 'gender' },
        { label: 'Current Latitude', key: 'current_latitude' },
        { label: 'Current Longitude', key: 'current_longitude' },
        { label: 'Registered Latitude', key: 'registered_latitude' },
        { label: 'Registered Longitude', key: 'registered_longitude' },
        { label: 'Date Of Birth', key: 'date_of_birth' },
        { label: 'Total Trips', key: 'total_trips' },
        { label: 'Rating', key: 'rating' },
        { label: 'User Wallet Balance', key: 'user_wallet_balance' },
    ];

    const handleSubmit = async () => {
        if (!selectedRow) {
            console.log("No user selected for transaction");
            return;
        }
    
        try {
            const token = localStorage.getItem('token');

            // Map 'credit' to 1 and 'debit' to 2
            const txnType = type === "credit" ? 1 : 2;
    
            const params = {
                token,
                txn_type: txnType,
                amount,
                user_id: selectedRow.user_id,
                user_type: 0, // assuming customer
                reason
            };
    
            const response = await axios.post(`${serverUrl}/admin/wallet_transactions`, params);
            await fetchData(); // Re-fetch updated data
            handleClose();
        } catch (error) {
            console.error('Error while submitting:', error.message);
        }
    };

    return(
        <div>

        {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>User</Typography>
            <Typography style={{ color: '#83888E'}}>User / Customer</Typography>

            <Grid2 container spacing={2} direction="row" alignItems="center"  wrap="nowrap" style={{ marginTop: '2%', marginBottom: '2%' }}>
                <Grid2 xs="auto">
                    <input type="number" placeholder="Customer Id" className='filterBtn' value={customerId} onChange={handleInputChange} min="0"
                    onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                          e.preventDefault();
                        }
                    }} />
                </Grid2>
                <Grid2 xs="auto">
                    <input type="number" placeholder="Customer Phone" className='filterBtn' value={customerPhone} onChange={handlePhoneChange} />
                </Grid2>
                {/* <Grid2 xs="auto" style={{marginLeft:'2%'}}>
                    <Button variant="contained" onClick={getFilteredData} style={{width: '170px', height: '44px', marginRight: '12px', backgroundColor: '#0065FF', textTransform:'none', borderRadius:'8px'}}> Apply Filter</Button>
                </Grid2> */}
                <Grid2 xs="auto">
                    <Button variant='contained' style={{width: '120px', height: '44px', backgroundColor:'#36C68F', textTransform:'none', borderRadius:'8px'}}> 
                        <CSVLink
                            data={allData}
                            headers={headers}
                            filename={"Customer Data.csv"}
                            style={{ textDecoration: 'none' }} // Add this line to remove underline
                        > 
                            <Typography sx={{color: '#fff'}}>Export CSV</Typography>
                        </CSVLink>
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            {/* <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header' active={orderBy === 'driver_name'} direction={orderBy === 'driver_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('driver_name')}>
                                    Name
                                </TableSortLabel>
                            </TableCell> */}
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header' active={orderBy === 'user_id'} direction={orderBy === 'user_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('user_id')} sx={{
                                        '& .MuiTableSortLabel-icon': {
                                            color: '#0065FF !important', // Change the arrow color
                                        },
                                    }}>
                                    Customer ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Customer</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Email</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Email Verification Status</TableSortLabel>
                            </TableCell>
                            {/* <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Phone No.</TableSortLabel>
                            </TableCell> */}
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Gender</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Date Of Birth</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> City</TableSortLabel>
                            </TableCell> 
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Registered City</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Current Latitude</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Current Longitude</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Registered Latitude</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> Registered Longitude</TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header' active={orderBy === 'total_trips'} direction={orderBy === 'total_trips' ? order : 'asc'}
                                    onClick={() => handleRequestSort('total_trips')} sx={{
                                        '& .MuiTableSortLabel-icon': {
                                            color: '#0065FF !important', // Change the arrow color
                                        },
                                    }}>
                                    Total Trips
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header' active={orderBy === 'rating'} direction={orderBy === 'rating' ? order : 'asc'}
                                    onClick={() => handleRequestSort('rating')} sx={{
                                        '& .MuiTableSortLabel-icon': {
                                            color: '#0065FF !important', // Change the arrow color
                                        },
                                    }}>
                                    Rating
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel className='table-header'> User Wallet Balance </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                    Action
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paginatedData.map((row) => {
                            // Find the city name for city_id
                            const city = clientCities.find(city => city.city_id === row.city_id);
                            const cityName = city ? city.city_name : '---';

                            // Find the city name for registered_city_id
                            const registeredCity = clientCities.find(city => city.city_id === row.registered_city_id);
                            const registeredCityName = registeredCity ? registeredCity.city_name : '---';

                            return (
                                <TableRow key={row.id}>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px', pr: '28px' }}>
                                            {row.user_id}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Grid2 container sx={{ width: 'auto', minWidth: '180px' }}>
                                            <Grid2>
                                                <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt={row.user_name} src={row.user_image} />
                                            </Grid2>
                                            <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                                                <Grid2>
                                                    <Typography>{row.user_name}</Typography>
                                                </Grid2>
                                                <Grid2>
                                                    <Typography sx={{ color: '#83888E', fontSize: '12px' }}>
                                                        {row.phone_number}
                                                    </Typography>
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>
                                    </TableCell>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'left' }}>{row.user_email}</Typography>
                                    </TableCell>
                                    <TableCell>{row.email_verification_status ==1 ? 'Verified' : 'Not Verified'}</TableCell>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '120px' }}>
                                            {row.gender === 1 ? 'Male' : row.gender === 2 ? 'Female' : 'Others'}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '120px' }}>
                                            {(row.date_of_birth).split('T')[0]}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>{cityName}</TableCell> {/* Display the city name */}
                                    <TableCell>{registeredCityName}</TableCell> {/* Display the registered city name */}
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '100px' }}>
                                            {row.current_latitude}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '100px' }}>
                                            {row.current_longitude}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '100px' }}>
                                            {row.registered_latitude}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'left', width: 'auto', minWidth: '100px' }}>
                                            {row.registered_longitude}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px', marginRight: '12px' }}>
                                            {row.total_trips}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: 'left' }}>
                                        {parseFloat(row.rating).toFixed(2)} 
                                        <img src={starIcon} height="12px" width="12px" style={{ marginLeft: '1%' }} />
                                    </TableCell>
                                    <TableCell>
                                        <Typography sx={{ textAlign: 'center', width: 'auto', minWidth: '100px' }}>
                                            {row.user_wallet_balance}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">

                                    <Button
                                    variant="contained"
                                    onClick={() => handleOpen(row)}
                                    sx={{
                                        backgroundColor: 'white',
                                        color: 'black',
                                        border: '1px solid black',
                                        textTransform: 'none',
                                        borderRadius: '8px', 
                                        width: 'auto', // Or set a specific width
                                        minWidth: '120px', 
                                        '&:hover': {
                                            backgroundColor: 'black',
                                            color: 'white',
                                        },
                                        '&:active': {
                                            backgroundColor: 'black',
                                            color: 'white',
                                        },
                                    }}
                                >
                                    Credit/Debit
                                </Button>
                                </TableCell>                                    
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>

                {/* Dialog */}
                <Dialog
                    open={open}
                    onClose={handleClose}
                    sx={{
                        '& .MuiDialog-paper': {
                            width: '50%',
                            maxWidth: 'none',
                        },
                    }}
                >
                    <DialogTitle
                        sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                        }}
                    >
                        User Wallet Transactions
                    </DialogTitle>
                    <DialogContent>
                        <Box display="flex" alignItems="center" mb={2}>
                            <Box width="30%" fontWeight="bold">
                                Type:
                            </Box>
                            <FormControl fullWidth>
                                <Select
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Type' }}
                                >
                                    <MenuItem value="credit">Credit</MenuItem>
                                    <MenuItem value="debit">Debit</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Box display="flex" alignItems="center" mb={2}>
                            <Box width="30%" fontWeight="bold">
                                Amount:
                            </Box>
                            <TextField
                                fullWidth
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="Enter Amount"
                            />
                        </Box>

                        <Box display="flex" alignItems="center" mb={2}>
                            <Box width="30%" fontWeight="bold">
                                Reason:
                            </Box>
                            <TextField
                                fullWidth
                                type="string"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                placeholder="Enter Reason"
                            />
                        </Box>
                    </DialogContent>

                    <Box display="flex" justifyContent="center" gap={2} mt={3} mb={2}>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            color="primary"
                            sx={{ width: '150px' }}
                            disabled={!amount || !reason} // Disable if amount or reason is empty
                        >
                            {type === 'credit' ? 'Credit' : 'Debit'}
                        </Button>
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            Cancel
                        </Button>
                    </Box>
                </Dialog>

                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            filteredRows.length
                        )} of ${filteredRows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                    
                        <div className="pagination-numbers">
                            {/* {[...Array(Math.ceil(filteredRows.length / rowsPerPage))].map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${
                                        page === index ? 'active' : ''
                                    }`}
                                >
                                    {index + 1}
                                </button>
                            ))} */}
                            {page > 1 && (
                                <>
                                    <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                        1
                                    </button>
                                    <span className="pagination-dots">...</span>
                                </>
                            )}
                            {[...Array(Math.ceil(filteredRows.length / rowsPerPage))]
                                .map((_, index) => index)
                                .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                .map((index) => (
                                    <button
                                        key={index}
                                        onClick={() => handleChangePage(null, index)}
                                        className={`pagination-number ${page === index ? 'active' : ''}`}
                                    >
                                        {index + 1}
                                    </button>
                            ))}

                            {page < Math.ceil(filteredRows.length / rowsPerPage) - 2 && (
                                <>
                                    <span className="pagination-dots">...</span>
                                    <button
                                        onClick={() => handleChangePage(null, Math.ceil(filteredRows.length / rowsPerPage) - 1)}
                                        className="pagination-number"
                                    >
                                        {Math.ceil(filteredRows.length / rowsPerPage)}
                                    </button>
                                </>
                            )}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(filteredRows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>
                
        </div>
        
    )
};

export default Dashboard;